import axios from 'axios';

import routes from '../router/routes';

// Добавим учетные данные запроса.
axios.defaults.withCredentials = true;

// Добавим перехватчик запросов.
axios.interceptors.request.use(
    function (request) {
        request.baseURL = '/api';
        request.headers['Content-Type'] = 'application/json';

        return request;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Добавим перехватчик ответов.
axios.interceptors.response.use(
    function (response) {
        // Выполните манипуляцию здесь и измените объект ответа
        return response;
    },
    function (error) {
        if (error.response?.status === 401) {
            // Получим роуты, не требующие обязательной авторизации.
            const optionalRoutes = routes.filter((route) => route.auth === 'optional').map((route) => route.path);

            // Выполните манипуляцию здесь, когда пользователь не авторизован
            if (optionalRoutes.indexOf(window.location.pathname) === -1) {
                // Редирект на основной маршрут приложения.
                return window.location.replace('/');
            }
        }

        return Promise.reject(error.response);
    }
);

export default {
    get: axios.get,
    put: axios.put,
    post: axios.post,
    patch: axios.patch,
    delete: axios.delete,
    // activity(type) {
    //     return axios.post('/user/activity', { type });
    // },
};
